<div style="display: flex; flex-direction: row; width: 100%; align-items: center;">
    <h2 style="margin-bottom: 0; margin-right: 0.5em; font-weight: 600 !important"><tra audio-slug slug="accessibility_settings"></tra></h2>
    <img style="height: 2em" src="https://eqao.vretta.com/authoring/user_uploads/6276/authoring/v4Asset_81/1642783446947/v4Asset_81.svg">
</div>
<br>
<ng-container *ngFor="let settingProp of Object.keys(accessibilitySettings)">
    <mat-slide-toggle *ngIf="accessibilitySettings[settingProp].isConfigurable" audio-slug [slug]="accessibilitySettings[settingProp].caption" [(ngModel)]="accessibility[settingProp]">
        <tra [slug]="accessibilitySettings[settingProp].caption"></tra>
    </mat-slide-toggle>
</ng-container>